<template>
  <div class="container">
    <NavTop :parentData="1" class="navbar"></Navtop>
    <!-- 未加载时 -->
    <!-- 轮播图 -->
    <div class="block" style="height: 450px;">
      <swiper class="swiper" :options="swiperOptions" style="height: 450px;">
        <swiper-slide style="height: 450px;" class="swiper_img" v-for="(slide, index) in slides" :key="index">
          <img style="height: 450px;" :src="slide.url" alt="Slide Image">
        </swiper-slide>
        <!--        @click.stop="clickRoute('/bannerDetail',slide.id)"-->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 学校新闻 -->
    <div class="index_news">
      <div class="content1 news_box">
        <div class="news_school">
          <div class="school_title">
            <span class="xw">{{ newsDetail.childName }}</span>
            <span class="title_all" @click="routerpushV('/common/more',newsDetail.id)">查看更多</span>
          </div>
          <div class="school_box">
            <div class="box_img">
              <swiper class="swiper1" :options="swiperOptions1">
                <swiper-slide class="swiper_img1" v-for="(slide, index) in slides1" :key="index">
                  <div class="swiper_img1_lefttop">
                    <span>{{ $extractDateTime(slide.createTime) }}</span>
                    <span>{{ $extractDateList(slide.createTime) }}</span>
                  </div>
                  <img @click.stop="clickRoute('/news',slide.id)" :src="slide.url" alt="Slide Image">
                  <div class="swiper_img1_title" @click.stop="clickRoute('/news',slide.id)">
                    <span>{{ slide.title }}</span>
                  </div>
                </swiper-slide>
                <div class="swiper-pagination1" slot="pagination"></div>
              </swiper>
            </div>
            <div class="box_item">
              <ul class="item_ul">
                <li class="item_li" v-for="(item2,index) in newsDetail.articleList" :key="index"
                    @click="clickRoute('/news',item2.id)">
                  <div>
                    <span class="item_li_span1">{{ item2.title }}</span>
                    <span class="item_li_span2">{{ $extractDate(item2.publishTime) }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 通知公告 东方映像  -->
    <div class="notification-container">
      <div class="container1">
        <div class="notification">
          <div class="notification_heard">
            <span>{{ noticeDetail.childName }}</span>
            <img @click="routerpushV('/common/more',noticeDetail.id)"
                 src="../../assets/images/more.png"
                 alt="视频新闻">
          </div>
          <div class="notification_body">
            <div class="article" v-for="(item,index) in noticeContent.articleList" :key="index"
                 @click="routerpushV('/common/detail',item.tabBarId,item.id)">
              <div class="article_">
                <div class="article_top">
                  <div class="article_top_co">
                    <span>{{ $extractDateTime(item.publishTime) }}</span>
                    <span>{{ $extractDateList(item.publishTime) }}</span>
                  </div>
                  <h6>{{ item.title }}</h6>
                </div>
                <div class="article_center">
                  {{ removeHtmlTags(item.content) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsVideo">
          <div class="newsVideo_title">
            <p>{{ dongFangData.childName }}</p>
          </div>
          <div class="newsVideo_content">
            <div class="newsVideo_content_b" @click="gpYouKu" @mouseover="easternZZYY"
                 @mouseleave="easternZZYC">
              <div class="newsVideo_content_b_one">
                <img :src="dongFangData_one.coverUrl" alt="Eastern Image"/>
                <p>{{ dongFangData_one.title }}</p>
              </div>
              <div class="newsVideo_content_b_two" :style="easternZZ">
                <img src="../../assets/images/play.png" alt>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产学研用 -->
    <div class="ZhuanLan">
      <div class="ZhuanLan_">
        <div class="ZhuanLan_one">
          <div class="ZhuanLan_one_tabs">
                <span :class="activeTab == 0?'active1':''"
                      @mouseover="clickZhuanLTabs(0)">
                {{ chanXueData.childName }}
                </span>
            <img style="cursor: pointer" v-if="activeTab == 0" @click="routerpushV('/common/more',chanXueData.id)"
                 src="../../assets/images/more.png"
                 alt="更多">
            <span :class="activeTab == 1?'active1':''"
                  @mouseover="clickZhuanLTabs(1)">
                {{ jiuYeData.childName }}
                </span>
            <img style="cursor: pointer" v-if="activeTab == 1" @click="routerpushV('/common/more',jiuYeData.id)"
                 src="../../assets/images/more.png"
                 alt="更多">
            <span :class="activeTab == 2?'active1':''"
                  @mouseover="clickZhuanLTabs(2)">
                {{ xiaoYuanData.childName }}
                </span>
            <img style="cursor: pointer" v-if="activeTab == 2" @click="routerpushV('/common/more',xiaoYuanData.id)"
                 src="../../assets/images/more.png"
                 alt="更多">
          </div>
          <div class="ZhuanLan_one_con">
            <div class="ZhuanLan_one_conV">
              <div class="ZhuanLan_one_conV_box" :class="activeTab == 0 ?'active4':''"
                   v-for="item1 in chanXueData.articleList" :key="item1.id"
                   @click="clickRoute('/news',item1.id)">
                <span class="ZhuanLan_one_conV_box1">{{ item1.title }}</span>
                <span class="ZhuanLan_one_conV_box2">{{ $extractDate(item1.publishTime) }}</span>
              </div>
              <div class="ZhuanLan_one_conV_box" :class="activeTab == 1 ?'active4':''"
                   v-for="item2 in  jiuYeData.articleList" :key="item2.id"
                   @click="clickRoute('/news',item2.id)">
                <span class="ZhuanLan_one_conV_box1">{{ item2.title }}</span>
                <span class="ZhuanLan_one_conV_box2">{{ $extractDate(item2.publishTime) }}</span>
              </div>
              <div class="ZhuanLan_one_conV_box" :class="activeTab == 2 ?'active4':''"
                   v-for="item3 in  xiaoYuanData.articleList" :key="item3.id"
                   @click="clickRoute('/news',item3.id)">
                <span class="ZhuanLan_one_conV_box1">{{ item3.title }}</span>
                <span class="ZhuanLan_one_conV_box2">{{ $extractDate(item3.publishTime) }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 专栏 -->
        <div class="ZhuanLan_two">
          <div class="ZhuanLan_two_title">
            <p>专栏</p>
          </div>
          <div class="ZhuanLan_two_list">
            <div class="ZhuanLan_two_listV" :class="index % 2 !== 0 ? 'active3' : ''"
                 v-for="(item,index) in ZhuanLanTitle"
                 :key="item.id" @click="goEastern(item.path)">
              <span>{{ index + 1 }}</span>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div class="footer">
      <div style="height: 20px;"></div>
      <div class="footer-container">
        <div class="footer-arrow left-arrow" @click="scrollFooter('left')">
          <div class="arrow-icon"></div>
        </div>
        <div class="footer-item" ref="footerItem">

          <div class="footer-itemV" @click="routerpushV('/common/more',717)">
            <img src="../../assets/images/home_bottom_04.jpg"/>
          </div>
          <div class="footer-itemV" @click="routerpushV('/common/more',718)">
            <img src="../../assets/images/home_bottom_05.jpg"/>
          </div>
          <div class="footer-itemV" @click="routerpushV('/common/more',728)">
            <img src="../../assets/images/ml003.jpg"/>
          </div>
          <div class="footer-itemV" @click="goTiaoZhuan('/convention',0)">
            <img src="../../assets/images/home_bottom_01.jpg"/>
          </div>
          <div class="footer-itemV" @click="goTiaoZhuan('/thematic/education',1)">
            <img src="../../assets/images/home_bottom_02.jpg"/>
          </div>
          <div class="footer-itemV" @click="goTiaoZhuan('http://www.moe.gov.cn/jyb_xwfb/xw_zt/moe_357/s7865/s8417/',2)">
            <img src="../../assets/images/home_bottom_03.jpg"/>
          </div>
        </div>
        <div class="footer-arrow right-arrow" @click="scrollFooter('right')">
          <div class="arrow-icon"></div>
        </div>
      </div>
    </div>
    <!-- 对话框 -->
    <el-dialog :visible.sync="centerDialogVisible" title="" width="500" center @close="closeDialog">
      <div>
        <video
          ref="videoElement"
          style="width: 100%; height: 100%;"
          controls>
          <source :src="videoUrl" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </el-dialog>
    <!--    <div style="width: 100%;height: 170px;"></div>-->
  </div>
</template>
<script>
import home from '@/api/home.js'
import {getBeforeList, getBanner, getAfterList, getNotices} from '@/api/homeIndex.js'

export default {
  data () {
    return {
      // 控制对话框
      centerDialogVisible: false,
      // 轮播
      swiperOptions: {
        pagination: {el: '.swiper-pagination', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 10000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 10000
      },
      slides: [],
      // 学校新闻轮播
      slides1: [],
      swiperOptions1: {
        pagination: {el: '.swiper-pagination1', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        },
        speed: 2000
      },
      // 走进东方遮罩层
      easternZZ: '',
      // 首页学校新闻数据
      newsDetail: [],
      // 通知公告数据
      noticeDetail: [],
      noticeContent: [],
      // 东方映像
      dongFangData: [],
      dongFangData_one: [],
      // 视频路径
      videoUrl: '',
      // 产学延用
      activeTab: 0, // 默认激活第一个标签
      tabs: [],
      chanXueData: [],
      jiuYeData: [],
      xiaoYuanData: [],
      // 子菜单值总和
      childMenu: [],
      // 校园导航
      // 专栏标题
      ZhuanLanTitle: [
        {
          path: '/convention',
          name: '党建专栏'
        },
        {
          path: '/common/section/more/53/145',
          name: '国防教育专栏'
        },
        {
          path: '/common/section/more/57/495',
          name: '数据安全专栏'
        },
        {
          path: '/common/section/more/57/496',
          name: '网络安全专栏'
        },
        {
          path: '/common/section/more/58/536',
          name: '语言文字专栏'
        }
      ],
      // 底部信息
      bottomData: [
        {
          path: '/convention',
          url: '../../assets/images/004.png'
        },
        {
          path: '/thematic/education',
          url: '../../assets/images/001.png'
        },
        {
          path: 'http://www.moe.gov.cn/jyb_xwfb/xw_zt/moe_357/s7865/s8417/',
          url: '../../assets/images/002.png'
        },
        {
          path: '/thematic/educationTwo',
          url: '../../assets/images/001.png'
        }
      ],
      // 主题教育
      zhuTiData: {},
      // 二十大精神
      ershiData: {},
      //校报
      schoolNewspaperData:{},
      //电视台
      schoolTVData:{},
    }
  },
  beforeCreate () {

  },
  created () {
    // this.getChild() // 获取列表
    // this.getWenZhangList()
  },
  mounted () {
    this.getBannerList() // 获取轮播图列表
    this.getNewsList() //学校新闻
    this.getNoticeList() //通知公告数据
    this.getNotices() // 通知公告列表数据
    this.getDongFangList() // 东方映像数据
    this.getChanXueList() //产学研用数据
    this.getJiuYeList() // 就业数据
    this.getXiaoYuanList() //校园数据
    // this.getZhuTiList()  // 主题教育
    // this.getErShiList()  // 二十大
    // this.getSchoolNewspaperList() //校报
    // this.getSchoolTvList() //电视台
  },
  methods: {
    // 校报
    getSchoolNewspaperList(){
      getAfterList({tabBarId: 717, parentId: 1}).then(res => {
        this.schoolNewspaperData = res.data
      })
    },
    //电视台
    getSchoolTvList() {
      getAfterList({tabBarId: 718, parentId: 1}).then(res => {
        this.schoolTVData = res.data
      })
    },
    /**
     * 学校新闻模块
     */
    getNewsList () {
      getAfterList({tabBarId: 64, parentId: 1}).then(res => {
        this.newsDetail = res.data
      })
    },

    /**
     * 通知公告模块
     */
    getNoticeList () {
      getBeforeList({tabBarId: 65, parentId: 1}).then(res => {
        this.noticeDetail = res.data
      })
    },
    /**
     * 通知公告内容
     * */
    getNotices () {
      getNotices({tabBarId: 65, parentId: 1}).then(res => {
        this.noticeContent = res.data
      })
    },
    /**
     * 东方映像模块
     */
    getDongFangList () {
      getBeforeList({tabBarId: 66, parentId: 1}).then(res => {
        this.dongFangData = res.data
        this.dongFangData_one = res.data.articleList[0]
        this.videoUrl = res.data.path
      })
    },
    /**
     * 产学研用模块
     */
    getChanXueList () {
      getAfterList({tabBarId: 67, parentId: 1}).then(res => {
        this.chanXueData = res.data
      })
    },
    /**
     * 就业信息模块
     */
    getJiuYeList () {
      getAfterList({tabBarId: 212, parentId: 1}).then(res => {
        this.jiuYeData = res.data
      })
    },
    /**
     * 招生动态模块
     */
    getXiaoYuanList () {
      getAfterList({tabBarId: 220, parentId: 1}).then(res => {
        this.xiaoYuanData = res.data
      })
    },
    /**
     * 主题教育模块
     */
    getZhuTiList () {
      getBeforeList({tabBarId: 535, parentId: 1}).then(res => {
        this.zhuTiData = res.data
      })
    },
    /**
     * 二十大模块
     */
    getErShiList () {
      getBeforeList({tabBarId: 534, parentId: 1}).then(res => {
        this.ershiData = res.data
      })
    },
    /**
     * 对话框
     * */
    handleClose (done) {
      this.$confirm('Are you sure to close this dialog?').then(() => {
        done()
      }).catch(() => {
        // catch error
      })
    },
    // 获取子模块
    // async getChild () {
    //   try {
    //     const res = await child.getChild({tabBarId: 1})
    //     // 子模块总和
    //     this.childMenu = res.data
    //     console.log(this.childMenu[0].articleList, 'lkdkjfasuhfkahs')
    //     // 学校新闻数据
    //     this.newsList = this.childMenu[0].articleList
    //     // 通知公告数据
    //     this.notices = this.childMenu[1].articleList
    //     // 产学延用
    //     this.chanXueData = this.childMenu[3].articleList
    //     this.jiuYeData = this.childMenu[4].articleList
    //     this.xiaoYuanData = this.childMenu[5].articleList
    //     // 函数取值
    //     const findMenuItems = (ids) => {
    //       return this.childMenu.filter(item => ids.includes(item.id))
    //     }
    //     // 产学延用标题
    //     this.tabs = findMenuItems([67, 212, 220])
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },
    // // 获取子模块文章列表
    // getWenZhangList () {
    //   const that = this
    //   // 获取学校新闻文章列表
    //   this.getArticle(64, 1, 10)
    //     .then((data) => {
    //       that.newsList = data
    //       console.log(data, '学校新闻文章列表')
    //     })
    //   // 获取通知公告
    //   this.getArticle(65, 1, 4)
    //     .then((data) => {
    //       that.notices = data
    //       console.log(data, '通知公告')
    //     })
    //   // 获取产学延用
    //   this.getArticle(67, 1, 10)
    //     .then((data) => {
    //       that.chanXueData = data
    //       console.log(data, '产学延用')
    //     })
    //   // 获取就业信息
    //   this.getArticle(212, 1, 10)
    //     .then((data) => {
    //       that.jiuYeData = data
    //       console.log(data, '就业信息')
    //     })
    //   // 获取校园生活
    //   this.getArticle(220, 1, 10)
    //     .then((data) => {
    //       that.xiaoYuanData = data
    //       console.log(data, '校园生活')
    //     })
    // },
    // 点击专栏
    goEastern (path) {
      this.$router.push(path)
    },
    // 移入专栏左部分标签
    clickZhuanLTabs (index) {
      this.activeTab = index
    },
    // 点击底部跳转
    goTiaoZhuan (path, index) {
      switch (index) {
        case 0:
          const routeData1 = this.$router.resolve(path)
          window.open(routeData1.href, '_blank')
          break
        case 1:
          const routeData2 = this.$router.resolve(path)
          window.open(routeData2.href, '_blank')
          break
        case 2:
          window.open(path, '_blank')
          break
        case 3:
          const routeData3 = this.$router.resolve(path)
          window.open(routeData3.href, '_blank')
          break
        case 4:
          const routeData4 = this.$router.resolve(path)
          window.open(routeData4.href, '_blank')
          break
      }
    },
    // 底部区域滚动
    scrollFooter(direction) {
      const footerItem = this.$refs.footerItem;
      if (!footerItem) return;

      const scrollAmount = 384; // 单个项目的宽度

      if (direction === 'left') {
        footerItem.scrollLeft -= scrollAmount;
      } else {
        footerItem.scrollLeft += scrollAmount;
      }
    },
    // 看视频
    gpYouKu () {
      this.centerDialogVisible = true
      this.$nextTick(() => {
        // 获取视频元素
        const videoElement = this.$refs.videoElement
        // 重置视频播放位置到开始
        videoElement.currentTime = 0
        // 播放视频
        videoElement.play()
      })
    },
    // 关闭对话框
    closeDialog () {
      const video = this.$refs.videoElement
      // 停止视频播放
      if (video) {
        video.pause()
        // video.src = '' // 重置视频源
      }
      console.log(123)
    },
    // 移入东方映像
    easternZZYY () {
      this.easternZZ = 'display:block'
    },
    // 移出东方映像
    easternZZYC () {
      this.easternZZ = 'display:none'
    },

    /**
     * 获取轮播图列表
     */

    getBannerList () {
      // 获取首页轮播图
      getBanner({bannerPath: '/'}).then(res => {
        this.slides = res.rows.filter(item => item.tabBarId == 1)
        this.slides1 = res.rows.filter(item => item.tabBarId == 64)
      })
    },
    // 获取首页文章
    async getArticle (tabBarId, pageNum, pageSize, status) {
      try {
        if (status) {
          const res = await home.getWenZhang({tabBarId: tabBarId, pageNum: pageNum, pageSize: pageSize, status: status})
          let data = res.rows
          return data
        }
        const res = await home.getWenZhang({tabBarId: tabBarId, pageNum: pageNum, pageSize: pageSize})
        let data = res.rows
        return data
      } catch (e) {
        console.error(e)
      }
    },
    // 点击学校新闻产学研用列表
    clickRoute (path, id) {
      this.$router.push(path + '/' + id)
    },
    // 过滤标签
    removeHtmlTags (input) {
      // 如果输入中包含 &nbsp;，则替换为普通空格
      let textWithSpaces = input
      if (textWithSpaces) {
        if (input.includes('&nbsp;')) {
          textWithSpaces = input.replace(/&nbsp;/gi, ' ')
        }
        // 使用正则表达式替换HTML标签
        return textWithSpaces.replace(/<[^>]*>?/gm, '')
      }
    },
    // 跳转
    routerpushV (path, tabBarId, id) {
      if (id) {
        this.$router.push({path: path + '/' + tabBarId + '/' + id})
        return
      }
      if (tabBarId) {
        this.$router.push({path: path + '/' + tabBarId})
      }
    },
    routerpush (item) {
      console.log(item, 'lll')
      switch (item.pathType) {
        case '1' :
          this.$router.push(item.path)
          break
        case '2' :
          window.location.href = item.path
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
// ----
.bgcolor {
  background-color: #f9f9f9;
}

.tabs {
  display: flex;
  cursor: pointer;
}

.tab {
  padding: 16px 20px;
  margin: 10px 0px 10px 0;
  border: 1px solid #ccc;
  border-bottom: none;
  transition: background-color 0.3s;
}

.tab_between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &:hover {
    color: #7c2c2c;
    cursor: pointer;
  }
}

/* 新闻轮播图 */
.active {
  background-color: #990000;
  color: #fff;
  border: 1px solid #ccc;
  border-bottom: 1px solid transparent;
  /* 使下边界看起来没有边框 */
}

.between {
  display: flex;
  flex-direction: row;
}

.announcements {
  width: 70%;

  h2 {
    margin: 20px 0;
    display: flex;
    justify-content: left;
  }
}

.ann_card {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.content {
  height: 500px;
  width: 800px;
  padding: 20px;
  border: 1px solid #cdcdcd;
  transform: translateY(-2%);
}

.card {
  width: 48%;
  height: 200px;
  margin: 20px 10px 20px 0;
  position: relative;
}

.card:hover {
  color: #8d080e;
  cursor: pointer;

  .bottom_date {
    background-color: #8d080e;
  }
}

.card-content {
  display: flex;
  flex-direction: row;
}

.bottom_date {
  width: 20%;
  height: 70px;
  color: #fff;
  background-color: #ccc;
  border-radius: 10px;
  margin: 0px 15px 0 0;

  .date_day {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 4px;
    //margin: 0 auto;
    padding-left: 15px;
  }

  .date_year {
    margin: 0 auto;
    padding-left: 10px;
    font-size: 12px;
  }
}

.card_text {
  display: flex;
  justify-content: left;
  margin: 20px 0;
}

.card_text:hover {
  color: #8d080e;
}

.eastern_images {
  width: 35%;

  h2 {
    margin: 20px 0;
    display: flex;
    justify-content: left;
  }

  img {
    padding: 10px;
    padding-bottom: 60px;
    background-color: #fff;
    width: 100%;
    height: 100%;
  }
}

.eastern_images_box {
  background-color: #fff;
  position: relative;
  height: 458px;

  &:hover {
    cursor: pointer;
  }

  .eastern_images_ZZ {
    position: absolute;
    display: none;
    top: 0;
    left: 0;
    width: 415px;
    height: 458px;
    background: rgba(0, 0, 0, 0.2);

    img {
      display: block;
      //width: 80px;
      //height: 80px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.2);
    }
  }
}

.eas_bottom_title {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.special-columns {
  margin: 20px 0;
}

.column {
  margin: 20px 0;
  border: 1px solid #CCCCCC;

  &:hover {
    cursor: pointer;
  }
}

.column_row {
  display: flex;
}

.column_id {
  background-color: #8d080e;
  padding: 20px 25px 20px 25px;
  color: #fff;
}

.column_idActive {
  background-color: #CCCCCC;
  padding: 20px 25px 20px 25px;
  color: #fff;
}

.column_title {
  padding: 20px;
  color: #666666;

  &:hover {
    color: #990000;
  }
}

.footer {
  background: #F9F9F9;
  height: 300px;

  .footer-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
    position: relative;
  }

  .footer-arrow {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    margin: 0 15px;

    &:hover {
      background-color: #990000;
      border-color: #990000;

      .arrow-icon {
        border-color: #fff;
      }
    }

    .arrow-icon {
      width: 12px;
      height: 12px;
      border-top: 2px solid #666;
      border-right: 2px solid #666;
      transition: all 0.3s ease;
    }
  }

  .left-arrow .arrow-icon {
    transform: rotate(-135deg);
    margin-left: 4px;
  }

  .right-arrow .arrow-icon {
    transform: rotate(45deg);
    margin-right: 4px;
  }

  .footer-item {
    width: 1200px;
    margin: 10px 0;
    display: flex;
    overflow-x: auto;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      display: none;
    }

    .footer-itemV {
      flex-shrink: 0;
      margin-left: 5px;
      img {
        width: 376px;
        height: 236px;
        cursor: pointer;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }
}

.jiuyXX:hover {
  color: #fff !important;
}


// 学校新闻
.index_news {
  height: 520px;
  background-color: #fff;

  .news_box {
    //height: 520px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .news_school {
      width: 1200px;
      height: 420px;
      padding: 50px 0;

      .school_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 45px;
        padding: 0 25px 0 0;
        border-bottom: 1px solid #CCCCCC;

        .xw {
          font-size: 24px;
          font-weight: bold;
          color: #444;
        }

        .title_all {
          text-decoration: none;
          color: #666;
          position: relative;
          font-size: 14px;

          &::after {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            top: 3px;
            right: -12px;
            border: 1px solid #666;
            border-left: none;
            border-bottom: none;
            transform: rotate(45deg);
          }

          &:hover {
            cursor: pointer;
            color: #8D080E;
          }
        }
      }

      .school_box {
        margin-top: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .box_img {
          width: 586px;
          height: 324px;
          background: #990000;
          overflow: hidden;
          position: relative;
        }

        .box_item {
          width: 614px;
          height: 324px;
          overflow: hidden;
          padding: 0 0 0 29px;

          .item_ul {
            width: 100%;
            height: 100%;

            .item_li {
              display: flex;
              justify-content: space-between;
              margin-bottom: 15px;

              &:hover {
                cursor: pointer;

                .item_li_span1 {
                  color: #8D080E !important;
                }

                .item_li_span2 {
                  color: #8D080E !important;
                }
              }

              div {
                display: flex;
                justify-content: space-between;
                width: 100%;

                span {
                  &:nth-child(1) {
                    width: 500px;
                    color: #333333;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    display: inline-block;
                  }

                  &:nth-child(2) {
                    color: #333333;
                    overflow: hidden;
                    white-space: nowrap;
                    //text-overflow: ellipsis;
                    display: inline-block;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// 通知公告
.notification-container {
  background: #F9F9F9;
  height: 540px;

  .container1 {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .notification {
      margin-top: 32px;
      width: 761px;
      margin-right: 34px;

      .notification_heard {
        display: flex;
        justify-content: space-between;

        span {
          font-size: 24px;
          color: #444;
          font-weight: bold;
        }

        img {
          width: 28px;
          height: 28px;
          cursor: pointer;
        }
      }

      .notification_body {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        height: 444px;
        overflow: hidden;

        .article {
          width: 48%;
          height: 195px;
          padding: 10px;
          background: #fff;
          margin-top: 27px;
          cursor: pointer;

          &:first-child {
            .article_top_co {
              background: #990000 !important;
            }
          }

          &:hover {
            .article_top_co {
              background: #990000 !important;
            }

            .article_center {
              color: #990000 !important;
            }

            h6 {
              color: #990000 !important;
            }
          }

          .article_ {
            .article_top {
              display: flex;
              justify-content: start;

              .article_top_co {
                background: #DDDDDD;
                display: flex;
                flex-direction: column;
                text-align: center;
                width: 62px;
                height: 62px;
                border-radius: 6px;
                margin-top: -18px;
                margin-right: 15px;
                margin-bottom: 15px;

                span {
                  &:nth-child(1) {
                    display: inline-block;
                    height: 24px;
                    color: #fff;
                    font-size: 24px;
                    margin: 8px 0;
                  }

                  &:nth-child(2) {
                    display: block;
                    height: 14px;
                    color: #fff;
                    font-size: 14px;
                  }
                }
              }

              h6 {
                font-size: 16px;
                color: #333333;
                font-weight: normal;
                line-height: 23px;
                flex: 1;
              }
            }

            .article_center {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666;
              line-height: 26px;
              height: 107px;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              display: -webkit-box;
            }
          }
        }
      }
    }

    .newsVideo {
      margin-top: 32px;
      width: 405px;

      .newsVideo_title {
        display: flex;
        justify-content: space-between;

        p {
          font-size: 24px;
          font-weight: bold;
          color: #444;
        }
      }

      .newsVideo_content {
        width: 405px;
        height: 420px;
        background: white;
        margin-top: 24px;

        .newsVideo_content_b {
          position: relative;
          cursor: pointer;

          .newsVideo_content_b_one {
            width: 385px;
            margin: 0 auto;

            img {
              width: 385px;
              height: 373px;
              display: block;
              position: relative;
              top: 10px;
            }

            p {
              font-size: 18px;
              font-weight: 400;
              color: #333333;
              margin: 18px 0;
              text-align: center;
            }
          }

          .newsVideo_content_b_two {
            position: absolute;
            display: none;
            top: 0;
            left: 0;
            width: 405px;
            height: 420px;
            background: red;
            background: rgba(0, 0, 0, 0.2);

            img {
              display: block;
              width: 80px;
              height: 80px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }
}

// 专栏
.ZhuanLan {
  background: #fff;

  .ZhuanLan_ {
    width: 1200px;
    margin: 31px auto;
    display: flex;
    align-items: stretch;

    .ZhuanLan_one {
      width: 766px;
      margin-right: 34px;
      display: flex;
      flex-direction: column;

      .ZhuanLan_one_tabs {
        position: relative;
        flex-shrink: 0;

        span {
          display: block;
          width: 121px;
          height: 41px;
          cursor: pointer;
          border: 1px solid #CCCCCC;
          border-bottom: none;
          padding: 10px 20px;
          color: #333333;
          font-size: 19px;
          white-space: nowrap;
          float: left;
        }

        img {
          display: block;
          position: absolute;
          top: 35%;
          right: -14px;
          transform: translate(-50%, -50%);
        }
      }

      .ZhuanLan_one_con {
        flex: auto;
        border: 1px solid #CCCCCC;
        height: 374px;
        overflow: hidden;

        &::-webkit-scrollbar {
          display: none;
        }

        .ZhuanLan_one_conV {
          display: block;
          padding: 12px;

          .ZhuanLan_one_conV_box {
            display: none;
            justify-content: space-between;
            color: #666;
            cursor: pointer;

            &:hover {
              color: #990000;
            }

            .ZhuanLan_one_conV_box1 {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              width: 646px;
              line-height: 21px;
            }

            .ZhuanLan_one_conV_box2 {
              display: block;
              padding: 7px 0;
            }
          }
        }
      }
    }

    .ZhuanLan_two {
      width: 400px;
      display: flex;
      flex-direction: column;

      .ZhuanLan_two_title {
        flex-shrink: 0;
        display: flex;
        justify-content: space-between;

        p {
          font-size: 24px;
          font-weight: bold;
          color: #444;
        }
      }

      .ZhuanLan_two_list {
        flex: auto;
        height: inherit;
        background: #F9F9F9;
        padding: 6px 6px 0px 6px;
        margin-top: 24px;

        .ZhuanLan_two_listV {
          display: flex;
          background: #fff;
          margin-bottom: 10px;
          border: 1px solid #CCCCCC;

          span {
            cursor: pointer;

            &:nth-child(1) {
              width: 60px;
              height: 60px;
              background: #990000;
              color: #fff;
              text-align: center;
              line-height: 60px;
              margin-right: 14px;
            }

            &:nth-child(2) {
              margin-right: 14px;
              display: block;
              line-height: 60px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              width: 356px;

              &:hover {
                color: #8D080E;
              }
            }
          }
        }
      }
    }
  }
}

// 其他样式
.content1 {
  width: 1200px;
  margin: 0 auto;
}

.active1 {
  background: #990000 !important;
  color: #fff !important;
}

.active2 {
  color: red !important;
}

.active3 {
  span {
    &:nth-child(1) {
      background: #CCCCCC !important;
    }
  }
}

.active4 {
  display: flex !important;
}
</style>
<!------------------------------------------------------------------------------------------------------------------------------------------>
<style lang="less" scoped>
.swiper {
  width: 100%;
  height: 452px !important;

  .swiper_img {
    cursor: pointer;
    height: 452px !important;

    img {
      width: 100%;
      height: 452px !important;
    }
  }
}

.swiper-pagination {
  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    background-color: #000 !important; /* 未选中时的背景色 */
    width: 8px;
    height: 8px;
    opacity: 0.3 !important;
    //transition: background-color 0.3s, transform 0.3s !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet-active {
    background-color: #8D080E !important; /* 选中时的背景色 */
    width: 15px !important; /* 选中时的宽度 */
    height: 8px;
    opacity: 1 !important;
    border-radius: 5px !important;
  }
}

// ----
.swiper1 {
  width: 586px;
  height: 324px;
  background: #990000;
  overflow: hidden;
  position: relative;

  .swiper_img1 {
    cursor: pointer;
    position: relative;

    .swiper_img1_lefttop {
      position: absolute;
      top: 15px;
      left: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 66px;
      height: 66px;
      background-color: #990000;
      padding: 4px;
      box-sizing: border-box;

      span {
        &:nth-child(1) {
          color: #fff;
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          line-height: 38px;
        }

        &:nth-child(2) {
          color: #fff;
          font-size: 14px;
          text-align: center;
        }
      }
    }

    .swiper_img1_title {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 30px;
      background-color: #990000;
      cursor: pointer;
      z-index: 9999;

      span {
        display: block;
        width: 376px;
        padding: 4px 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        color: #fff;
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.swiper-pagination1 {
  position: absolute;
  bottom: 0 !important;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
  z-index: 9999;
  width: 100%;
  height: 30px;
  padding-right: 35px;
  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    background-color: #990000 !important; /* 未选中时的背景色 */
    width: 12px;
    height: 12px;
    border: 1px solid #ffffff;
    opacity: 0.9 !important;
    box-sizing: content-box;
    //transition: background-color 0.3s, transform 0.3s !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #fff !important; /* 选中时的背景色 */
    width: 12px !important;
    height: 12px !important;
    opacity: 1 !important;
    border-radius: 50% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/index.vue